export default {
    SET_PRODUCTS(state, products) {
        state.products = products;
    },
    UPDATE_PRODUCTS(state, products) {
        const productIndex = state.products.items.findIndex((product) => product.id === products.id)
        Object.assign(state.products.items[productIndex], products)
    },
    CREATE_PRODUCTS(state, product) {
        state.products.items.unshift(product);
    },
    DELETE_PRODUCTS(state, id) {
        state.products.items.findIndex((element) => element.id === id);
    },
    FETCH_PRODUCTS(state, products) {
        state.products = products;
    }
}
